var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-end mb-0"},[_c('v-btn',{attrs:{"color":"error"},on:{"click":_vm.deleteLogin}},[_c('v-icon',[_vm._v("mdi-trash-can")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }